// @flow

import React from 'react';
import CarBlock from './carBlock.container';

type Props = {
  flapover_text: string,
  query_data: Object,
  pdb_preselected_package: string,
  pdb_id?: string,
  pdbId?: string,
};

const ACFCarBlock = ({
  flapover_text,
  pdb_preselected_package,
  pdb_id,
  pdbId,
  query_data,
}: Props) => (
  <CarBlock
    flapoverText={flapover_text}
    pdbId={pdb_id || pdbId}
    queryData={query_data}
    packageId={pdb_preselected_package}
  />
);

ACFCarBlock.defaultProps = {
  pdb_id: '',
  pdbId: '',
};

export default ACFCarBlock;
